import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby'

import { useDate } from '../../hooks/useDate';

const LDN = 'London';
const SF = 'San Francisco';
const toCountdownEnd = 'countdownEnd';

const Countdown = ({ location }) => {
  const scheduleQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        preliminarySchedule (
          options: {
            cachebust: true
          }
        ) {
          id
          data {
            location
            title
            end
          }
        }
      }
    }
  `);

  const { date: currDate } = useDate(1); // refresh every 1 sec

  const [countdownTo, setCountdownTo] = useState({});

  useEffect(() => {
    if (!scheduleQuery) {
      return;
    }

    const list = scheduleQuery?.allBuilderModels?.preliminarySchedule;

    let newCDTo = {};
    [LDN, SF].forEach((loc) => {
      list
        .filter((item) => item.data.location === loc)
        .forEach((ev) => {
          if (ev.data.title === toCountdownEnd) {
            newCDTo[loc] = new Date(ev.data.end);
          }
        });
    });
    setCountdownTo(newCDTo);
  }, [scheduleQuery]);

  return (
    <div className={'sec-title pt-20 md-pt-10 pb-20 md-pb-10'}>
      <div className='title text-center'>
        <h2 className='color-commcon mb-0 countdown'>
          {countdownString(currDate, countdownTo[location])}
        </h2>
      </div>
    </div>
  );
};

export default Countdown;

const countdownString = (current, target) => {
  if (!current || !target || current >= target) {
    return '0 days : 0 h : 0 min : 0 sec';
  }
  const diff = Math.ceil((target - current) / 1000); // sec
  const sec = diff % 60;
  const grossMin = Math.floor(diff / 60);
  const min = grossMin % 60;
  const grossHour = Math.floor(grossMin / 60);
  const hour = grossHour % 24;
  const days = Math.floor(grossHour / 24);

  return (
    <>
      <span>{leadingZero(days)}&nbsp;day{days === 1 ? '' : 's'}</span>
      <span> : </span>
      <span>{leadingZero(hour)}&nbsp;hour{hour === 1 ? '' : 's'}</span>
      <span> : </span>
      <span>{leadingZero(min)}&nbsp;min&nbsp;:&nbsp;{leadingZero(sec)}&nbsp;sec</span>
    </>
  );
};

const leadingZero = (num) => {
  if (Math.floor(num / 10) === 0) {
    return `0${num}`;
  }
  return num;
};
